import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobile-preview-1x1Yb",
  "use": "mobile-preview-1x1Yb-usage",
  "viewBox": "0 0 13 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 22\" id=\"mobile-preview-1x1Yb\"><path d=\"M2 3v16a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm8-3a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h7zM6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol